<!--
 * @Descripttion: 满赠弹出框
 * @version:
 * @Author: lt
 * @Date: 2021-09-14 13:50:09
 * @LastEditors: Jerry
 * @LastEditTime: 2022-02-17 15:36:20
-->
<template>

  <el-dialog :visible.sync="show" width="60%" class="gift_daig" title="">
    <!-- 赠品异常提醒弹窗  start-->
    <div class="gift_daig_Msg">
      <div class="gift_daig_title">赠品</div>
      <div class="gift_daig_content">
        <div class="gift_daig_child_title">
          <span class="item_name">提示1</span>
          <span class="item_type">以下商品库存不足</span>
          <div class="gift_daig_content_good">
            <div v-for="(i,k) in lessStack" :key="k" class="gift_daig_content_itemGood">
              <div class="gift_daig_content_img"><img :src="i.Logo"></div>
              <div class="gift_daig_content_dec">
                <div>
                  {{ i.Name }}
                </div>
                <div>
                  规格：{{ i.Specifications }}/{{ i.Unit }}
                </div>
                <div class="gift_daig_content_dec_last">
                  <span>赠送数量：{{ i.SendCount }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="gift_daig_child_title">
          <span class="item_name">提示2</span>
          <span class="item_type">以下赠品已赠完</span>
          <div class="gift_daig_content_good">
            <div v-for="(i,k) in noStack" :key="k" class="gift_daig_content_itemGood">
              <div class="gift_daig_content_img"><img :src="i.Logo"></div>
              <div class="gift_daig_content_dec">
                <div>
                  {{ i.Name }}
                </div>
                <div>
                  规格：{{ i.Specifications }}/{{ i.Unit }}
                </div>
                <div class="gift_daig_content_dec_last">
                  <span>赠送数量：{{ i.SendCount }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <div class="daig_btn">
      <el-button @click="cancel">取消</el-button>
      <el-button type="primary" @click.stop="surenext()">继续支付</el-button>
    </div>
    <!-- 选择赠品弹窗  end-->
  </el-dialog>
</template>

<script>
import {
  BaseMixin
} from '@/mixins/BaseMixin'
export default {
  name: 'GiftDaigItem',
  mixins: [BaseMixin],
  props: {
    // 选择赠品
    'CommodityGifts': {
      type: Array,
      default: () => {
        return []
      }
    },
    // 选择赠品
    'Activitys': {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      show: false,
      // remind:异常提醒 chose:选择赠品
      type: 'remind',
      noStack: [], // 无库存集合
      lessStack: [] // 库存不足集合
    }
  },
  watch: {
    'show': function(val) {
      if (val) {
        this.checkGoods()
      } else {
        // 初始化所以

      }
    },
    deep: true
  },
  mounted() {

  },
  created() {},
  methods: {
    checkGoods() {
      const arry = this.Activitys.map((item) => item.Freebies).flat(Infinity)
      console.log(arry)
      this.noStack = arry.filter((item) => item.Count == 0)
      this.lessStack = arry.filter((item) => item.Count > 0)
    },
    surenext() {
      this.show = false
      this.$emit('surenext', true)
    },
    cancel() {
      this.show = false
      this.$emit('surenext', false)
    }
    // 点击选择

  }
}
</script>

<style lang="less" scoped>
  @import url("~@/components/style/GiftDaigItem");

  /deep/.el-dialog__body {
    padding: 0;
  }

  /deep/.el-dialog__header {
    padding: 0;
  }
</style>
